import angular from 'angular';
import loanRedirect from './loanRedirect';

export default angular
  .module('components.loanRedirect', [])
  .component('loanRedirect', loanRedirect).name;
